<template>
  <div >
    <div class="loginbg">
      <div class="page-width">
        <div class="logins">
          <div class="text-center">
            <img src="../../assets/images/loginlogo.png" />
          </div>
          <div class="mainscontainer">
            <bind-index></bind-index>
          </div>
          <div class="foot">Copyright © 2019 jxjypt.cn All Rights Reserved | <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #333333">京ICP备17043231号</a><br/>
            出版物许可证：新出发京零字第海180088号 <br/>电信业务经营许可证编号：京B2-20190114 京公网安备 11010802031480号</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
   import BindIndex from './components/BindIndex'
  export default {
    name: 'userbind',
    components: {
      BindIndex
    },
    data: function () {
      return {
        arrs: [],
        sex: true
      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  .page-width{
    width:$pageWidth;
    margin:0 auto;
  }
  .loginbg{
    min-height:100%;
    height: calc(100vh);
    background:url("../../assets/images/loginbg1.jpg") no-repeat center center;
  }
  .logins{
    width:820px;
    margin:0 auto;
    margin:0 auto;
    padding-top:100px;
  }
  .mainscontainer{
    margin-top:30px;
  }
  .foot{
    text-align:center;
    margin-top:30px;
    line-height:28px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/userbind/Index.vue